module.exports = __webpack_public_path__ + "fd8506d2e21780619b68e5813264bf71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/synchrony-logo.jpg
// module id = 220
// module chunks = 1